module.exports = "<table class=\"role-table\" border=\"1\">\n    <tr>\n        <td></td>\n        <td> アカウント情報 変更 </td>\n        <td> 機器情報 変更 </td>\n        <td> 機器情報 閲覧 </td>\n    </tr>\n    <tr>\n        <th>アカウント管理者</th><td>◯</td><td>◯</td><td>◯</td>\n    </tr>\n    <tr>\n        <th>オペレータ</th><td>×</td><td>◯</td><td>◯</td>\n    </tr>\n    <tr>\n        <th>閲覧者</th><td>×</td><td>×</td><td>◯</td>\n    </tr>\n    <tr>\n        <th>制限付き閲覧者</th><td>×</td><td>×</td><td>△<br>(機器が制限されます)</td>\n    </tr>\n</table>\n"


//////////////////
// WEBPACK FOOTER
// ./public/dev/app/end_user/role_table.html
// module id = 559
// module chunks = 0